import type { FieldHistory } from "../../hooks/useCatalogFieldHistory";
import {
  FIELD_HISTORY_EMPTY_DESCRIPTION,
  FIELD_HISTORY_EMPTY_TITLE,
  FIELD_HISTORY_ERROR_FALLBACK,
  FIELD_HISTORY_LOADING_LABEL,
} from "../../constants/caseReviewLabels";
import {
  CR_HISTORY_CLASS,
  CR_HISTORY_EMPTY_CLASS,
  CR_HISTORY_EMPTY_TITLE_CLASS,
  CR_HISTORY_ENTRY_ARROW_CLASS,
  CR_HISTORY_ENTRY_CHANGE_CLASS,
  CR_HISTORY_ENTRY_CLASS,
  CR_HISTORY_ENTRY_FROM_CLASS,
  CR_HISTORY_ENTRY_REASON_CLASS,
  CR_HISTORY_ENTRY_SOURCE_CLASS,
  CR_HISTORY_ENTRY_TO_CLASS,
  CR_HISTORY_ENTRY_TO_PII_CLASS,
  CR_HISTORY_ENTRY_WHEN_CLASS,
  CR_HISTORY_ENTRY_WHO_CLASS,
  CR_HISTORY_ERROR_CLASS,
  CR_HISTORY_LIST_CLASS,
  CR_HISTORY_STATUS_CLASS,
} from "../../../theme/catalogThemeClasses";

/**
 * Dumb renderer for `useCatalogFieldHistory`'s prepared entries. No fetching of its own — the
 * popover that owns this component decides when the hook is `enabled` and passes on what it returns.
 */
export function FieldHistoryList({ history }: { history: FieldHistory }) {
  if (history.status === "idle" || history.status === "loading") {
    return <p className={CR_HISTORY_STATUS_CLASS}>{FIELD_HISTORY_LOADING_LABEL}</p>;
  }
  if (history.status === "failed") {
    return <p role="alert" className={CR_HISTORY_ERROR_CLASS}>{history.error ?? FIELD_HISTORY_ERROR_FALLBACK}</p>;
  }
  if (history.entries.length === 0) {
    return <p className={CR_HISTORY_EMPTY_CLASS}>
      <span className={CR_HISTORY_EMPTY_TITLE_CLASS}>{FIELD_HISTORY_EMPTY_TITLE}</span> {FIELD_HISTORY_EMPTY_DESCRIPTION}
    </p>;
  }
  return (
    <div className={CR_HISTORY_CLASS} data-testid="field-history">
      <ol className={CR_HISTORY_LIST_CLASS}>
        {history.entries.map((entry) => (
          <li key={entry.id} className={CR_HISTORY_ENTRY_CLASS}>
            <div className={CR_HISTORY_ENTRY_WHEN_CLASS}>{entry.when}</div>
            <div className={CR_HISTORY_ENTRY_CHANGE_CLASS}>
              <span className={CR_HISTORY_ENTRY_FROM_CLASS}>{entry.from}</span>
              <span aria-hidden="true" className={CR_HISTORY_ENTRY_ARROW_CLASS}>→</span>
              <span className={entry.isPii ? CR_HISTORY_ENTRY_TO_PII_CLASS : CR_HISTORY_ENTRY_TO_CLASS}>{entry.to}</span>
            </div>
            <div className={CR_HISTORY_ENTRY_WHO_CLASS}>{entry.who}</div>
            {entry.source && <div className={CR_HISTORY_ENTRY_SOURCE_CLASS}>{entry.source}</div>}
            {entry.reason && <div className={CR_HISTORY_ENTRY_REASON_CLASS}>“{entry.reason}”</div>}
          </li>
        ))}
      </ol>
    </div>
  );
}
